import React, {PureComponent} from 'react';
import { connect } from 'dva';
import { Button, Drawer, Row, Col } from 'antd';
import ProductItem from './ProductItem';
import ProductSummary from './ProductSummary';
import { isMobile, isBrowser } from 'react-device-detect';
import { mapStateToProps } from "../../../lib/Common";
//import { mapStateToProps } from "/lib/Common";

import SortPrice from './SortPrice';
import FilterCity from './FilterCity';

class ListPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      view: 'list',
//      expand:false,
      selected: null
    };

    this.onSelectItem  = this.onSelectItem.bind(this);
    this.onClosePanel = this.onClosePanel.bind(this);
//    this.onExpand  = this.onExpand.bind(this);
  }

  onSelectItem(item, e){
    console.info(item);
    e.preventDefault();
    this.setState({selected: item});
  }

  onClosePanel(){
    this.setState({selected: null});
  }
/*
  onExpand(){
    this.setState({expand: true});
  }
*/
  render() {
    const { items, asPage, onClose, model} = this.props;
    const { selected, expand } = this.state;
    const w = isMobile?'95%':375;

    return (
      <div className='container SaleSlide'>
        {asPage ?
          <SortPrice />
          :
        <Row className="pt-3 SaleSlide__header" gutter={8}>
          <Col xs={6} lg={2}>
            <Button
//              style={{width: '100%', background: '#000', border: '1px solid #333'}}
              block={true}
              onClick={onClose}
              type='primary'>閉じる</Button>
          </Col>
          <Col xs={9} lg={11}>
            <SortPrice />
            {/*
            <SortPrice
              model={model}
            />
            */}
          </Col>
          <Col xs={9} lg={11}>
            {/*            <FilterCity/> */}
          </Col>
        </Row>
        }

        <hr className='pb-3'/>

        {items &&
        <section className='travel-sale-list'>
          <Row type="flex" gutter={24}>
            <Col lg={24}>
              <div>
                {this.state.view == 'grid' ?
                  <Row type="flex" gutter={24}>
                    {items.map((item, idx) => (
                      <Col key={idx} xs={12} sm={8}>
                        <ProductItem
                          item={item}
                          onSelect={e => this.onSelectItem(item, e)}
                          view='grid'/>
                      </Col>
                    ))}
                  </Row>
                  :
                  <div>
                    {items.map((item, idx) => (
                      <ProductItem
                        key={idx}
                        item={item}
                        onSelect={e => this.onSelectItem(item, e)}
                        view='list'/>
                    ))}
                  </div>
                }
              </div>
            </Col>
          </Row>
        </section>
        }

        {selected &&
        <Drawer
          width={w}
          placement="right"
          closable={true}
          onClose={this.onClosePanel}
          visible={!!selected}
        >
          <ProductSummary item={selected} onClosePanel={this.onClosePanel}/>
        </Drawer>
        }
      </div>
    );
  }
}

//export default ListPage;
export default connect(mapStateToProps)(ListPage);
/*
export default connect(({ core, travel }) => ({
  core, travel
}))(ListPage);
*/




// WEBPACK FOOTER //
// ./src/pages/travel/components/ListPage.js